import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '../environments/environment';

function getAuthConfig(): AuthConfig {
  const appConfig = getAppConfig();
  return {
    issuer: 'https://login.microsoftonline.com/' + appConfig.tenantId + '/v2.0',
    redirectUri: window.location.origin + '/login',
    clientId: appConfig.clientId,
    responseType: 'code',
    showDebugInformation: true,
    silentRefreshTimeout: 3000,
    strictDiscoveryDocumentValidation: false,
    scope: 'openid api://' + appConfig.clientId + '/' + appConfig.scope
  };
}

export const authConfig: AuthConfig = getAuthConfig();
export const appConfig: AuthConfig = getAppConfig();

export function getAppConfig() {
  const hostname = window.location.hostname;
  if (hostname.includes('greybee') || hostname.includes('localhost')) {
    return environment.greybeeConfig;
  } else if (hostname.includes('skills')) {
    return environment.skillsConfig;
  } else {
    throw new Error('No matching environment configuration found for domain: ' + hostname);
  }
}
